import script from "./booking.vue?vue&type=script&setup=true&lang=js"
export * from "./booking.vue?vue&type=script&setup=true&lang=js"

import "./booking.vue?vue&type=style&index=0&id=d2234972&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2234972"]])

export default __exports__